// import moesifBrowser from 'moesif-browser-js'

const enablePendo = process.env.REACT_APP_ENABLE_PENDO === 'true';
const enableMoesif = process.env.REACT_APP_ENABLE_MOESIF === 'true';
const moesifApplicationId = process.env.REACT_APP_MOESIF_APPLICATION_ID

if (enableMoesif) {
    try {
        // window.moesif = moesifBrowser.init({ applicationId: moesifApplicationId });
    } catch (e) {
        console.error('Error initializing Moesif:', e);
    }
}

if (enablePendo && window.pendo) {
    try {
        // Initialize as anonymous visitor: https://support.pendo.io/hc/en-us/articles/360032202751-Anonymous-visitors
        window.pendo.initialize({ visitor: { id: '' } });
    } catch (e) {
        console.error('Error initializing Pendo:', e);
    }
}

class Metrics {
    pendoEnabled = enablePendo;
    moesifEnabled = enableMoesif;

    isMoesifAvailable() {
        return this.moesifEnabled && window.moesif;
    }

    isPendoAvailable() {
        return this.pendoEnabled && window.pendo;
    }

    track(eventName, eventData = {}) {
        if (this.isMoesifAvailable()) {
            try {
                window.moesif.track(eventName, eventData);
            } catch (e) {
                console.error('Error tracking events with Moesif:', e);
            }
        }

        if (this.isPendoAvailable()) {
            try {
                window.pendo.track(eventName, eventData);
            } catch (e) {
                console.error('Error tracking events with Pendo:', e);
            }
        }
    }
}

export default new Metrics();
